export default function Marquee({ items }) {
  const row = [...items, ...items];
  return (
    <div className="relative flex overflow-hidden border-y border-black/5 bg-white py-6" data-testid="marquee">
      <div className="flex shrink-0 animate-marquee gap-10 pr-10">
        {row.map((t, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap text-2xl font-bold tracking-tight text-neutral-300 sm:text-3xl">
            {t}<span className="h-1.5 w-1.5 rounded-full bg-brand" />
          </span>
        ))}
      </div>
    </div>
  );
}
